export default {
    _prefix: "npsQuestionOptions",
    labels: {
        clearAnswer: "Clear Answer",
        error: (data: { total: number }) =>
            "Response must be less than {{total}} characters",
        lowNpsScore: "Not at all likely",
        highNpsScore: "Extremely likely",
        followUpExplanation: "Follow Up Explanation",
    },
};
